function toggleMcrColSeo(button) {
  const wrapper = button.closest('.mcr-col-seo-wrapper');
  const extraContent = wrapper.querySelector('.mcr-col-seo-extra');
  const isExpanded = extraContent.style.maxHeight && extraContent.style.maxHeight !== '0px';

  if (isExpanded) {
    extraContent.style.maxHeight = '0px';
    button.textContent = 'Read More';
  } else {
    extraContent.style.maxHeight = extraContent.scrollHeight + 'px';
    button.textContent = 'Read Less';
  }
}

document.querySelectorAll('.mcr-col-seo-faq-toggle').forEach(button => {
  button.addEventListener('click', () => {
    const answer = button.nextElementSibling;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !expanded);
    answer.style.maxHeight = expanded ? '0px' : answer.scrollHeight + 'px';
  });
});